import { SelectedItem } from "@/3d/SelectedItem";
import { MaterialTextures } from "@/state/MaterialResources";
import React, { useMemo } from "react";
import { ColorRepresentation, PlaneGeometry } from "three";

type Props = {
    width: number;
    height: number;
    textures: MaterialTextures;
    position: [x: number, y: number, z: number];
    rotation: [x: number, y: number, z: number];
    receiveShadow?: boolean;
    color?: ColorRepresentation;
    skipColorTexture?: boolean;
    selectedItem?: SelectedItem;
};

export const TexturedPlaneMesh: React.FC<Props> = ({
    width,
    height,
    textures,
    position,
    rotation,
    receiveShadow,
    color,
    skipColorTexture,
    selectedItem,
}) => {
    const { geometry } = useMemo(() => {
        const geometry = new PlaneGeometry(width, height);

        // resize uvs
        const uvs = geometry.attributes.uv;
        for (let i = 0; i < uvs.count; i++) {
            uvs.array[i * 2] = uvs.array[i * 2] * width * 0.4;
            uvs.array[i * 2 + 1] = uvs.array[i * 2 + 1] * height * 0.4;
        }

        return { geometry };
    }, [width, height]);

    return (
        <mesh
            position={position}
            rotation={rotation}
            receiveShadow={receiveShadow}
            geometry={geometry}
            userData={selectedItem}
        >
            <meshStandardMaterial
                map={skipColorTexture ? undefined : textures.color}
                roughnessMap={textures.roughness}
                normalMap={textures.normal}
                bumpMap={textures.displacement}
                color={color}
            />
        </mesh>
    );
};
